import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Service } from '../service';
import { JobTitle } from '../../models/jobtitle/jobtitle';

@Injectable()
export class JobTitleService extends Service{

    public jobTitles: JobTitle[];
    public jobTitlesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.jobTitles = [];
        this.jobTitlesObject = {};
    }

    public getAll(): Observable<JobTitle[]> {
        if (!!this.jobTitles && this.jobTitles.length > 0) {
            return Observable.create((observer: Subscriber<JobTitle[]>) => {
                observer.next(this.jobTitles);
                observer.complete();
            });
        }
        const url = 'jobtitles/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.jobTitles = r.Result;
                this.jobTitlesObject = this.jobTitles.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.jobTitles;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/jobtitle/jobtitle.service.ts